<template>
  <div class="modal-wrapper">
    <div class="modal fade show" style="display: block;" @click="modal_click($event)" tabindex="-1" role="dialog" aria-modal="true">
      <div class="modal-dialog modal-lg modal-dialog-scrollable" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="modal-title">{{ record.investment_name }}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-6">
                <div class="row">
                  <div class="col-8"><strong>{{ $t('total capital cost' + budgetType) }}</strong></div>
                  <div class="col-4">{{ totalCapitalCost | formatMoney }}</div>
                </div>
                <div class="row">
                  <div class="col-8"><strong>{{ $t('Amount funded') }}</strong></div>
                  <div class="col-4">{{ record.sum_funded | formatMoney }}</div>
                </div>
                <div class="row">
                  <div class="col-8"><strong>{{ $t('Amount unfunded') }}</strong></div>
                  <div class="col-4">{{ record.sum_unfunded | formatMoney }}</div>
                </div>
              </div>
              <div class="col-6 preliminary-border" v-if="preliminary_cost">
                <div class="row">
                  <div class="col-8"><small>{{ $t('preliminary-' + budgetType + '-cost') }}</small></div>
                  <div class="col-4">{{ preliminary_cost | formatMoney }}</div>
                </div>
                <div class="row">
                  <div class="col-8"><small>{{ $t('preliminary-amount-forecasted') }}</small></div>
                  <div class="col-4">{{ preliminary_forecasted | formatMoney }}</div>
                </div>
                <div class="row">
                  <div class="col-8"><small>{{ $t('preliminary-amount-unfunded') }}</small></div>
                  <div class="col-4">{{ preliminary_unfunded | formatMoney }}</div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-8">
                <div v-if="record.sum_previously_approved_project_funding" class="row">
                  <div class="col-6"><strong>{{ $t('previously-approved-project-funding') }}</strong></div>
                  <div class="col-6">{{ record.sum_previously_approved_project_funding | formatMoney }}*</div>
                </div>
                <div class="row">
                  <div class="col-6"><strong>{{ $t('aggregates.department') }}</strong></div>
                  <div class="col-6">{{ record.department }}</div>
                </div>
                <div class="row">
                  <div class="col-6"><strong>{{ $t('aggregates.service_area') }}</strong></div>
                  <div class="col-6">{{ record.service_area }}</div>
                </div>
                <div class="row">
                  <div class="col-6"><strong>{{ $t('aggregates.investment_type') }}</strong></div>
                  <div class="col-6">{{ record.investment_type }}</div>
                </div>
                <div class="row">
                  <div class="col-6"><strong>{{ $t('aggregates.spap_theme') }}</strong></div>
                  <div class="col-6">{{ record.spap_theme }}</div>
                </div>
                <div class="row">
                  <div class="col-6"><strong>{{ $t('aggregates.lifecycle_activity_driver') }}</strong></div>
                  <div class="col-6">{{ record.lifecycle_activity_driver }}</div>
                </div>
                <div class="row" v-if="record.class_estimate">
                  <div class="col-6"><strong>{{ $t('Class estimate') }}</strong></div>
                  <div class="col-6">{{ (record.class_estimate | parseInt) || 'N/A'}}</div>
                </div>
                <div class="row" v-if="record.ward">
                  <div class="col-6"><strong>{{ $t('aggregates.ward') }}</strong></div>
                  <div class="col-6">{{ record.ward }}</div>
                </div>
              </div>
              <div class="col-4">
                <div class="row">
                  <div class="col">
                    <GmapMap v-if="location" :center="location" :zoom="zoom" style="width: 100%; height: 300px" ref="map" class="box">
                      <GmapMarker  :position="location" :options="marker_options(record)" :clickable="false"></GmapMarker>
                    </GmapMap>  
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col">
                {{ record.project_details }}
              </div>
            </div>
            <div class="row">
              <div class="col">
                <cashflow-chart v-if="cashflow_records.length" :records="cashflowRecords"></cashflow-chart>
              </div>
            </div>
            <div class="row" v-if="record.sum_previously_approved_project_funding">
              <div class="col">
                <p v-html="$t('additional_info')"></p>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="close">{{ $t('close')  }}</button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-backdrop"></div>
  </div>
</template>

<script>

function hasParentWithClass(event, className) {
  let target = event.target;
  
  while (target !== document.documentElement) {
    if (target.classList.contains(className)) {
      return true;
    }
    
    target = target.parentNode;
  }
  
  return false;
}

import {gmapApi} from 'vue2-google-maps'
import OpenData from '../libraries/OpenData';
import CashflowChart from './CashflowChart';

const WINNIPEG_CENTRE = {lat: 49.86, lng: -97.158465};

export default {
  props: ["record",'cashflow_years', 'wheres', 'budgetType'],

  data() {
    return {
      zoom: 10,
      centre: WINNIPEG_CENTRE,
      cashflow_records: [],
      polygon_default_options: {
        strokeOpacity: 0.5,
        strokeWeight: 1,
        fillOpacity: 0.2,
        fillColor: "black",
      },
      infoOptions: {
        content: "",
        //optional: offset infowindow so it visually sits nicely on top of our marker
        pixelOffset: {
          width: 0,
          height: -35
        }
      },
    };
  },
  created() {
    this.fetch_cashflow_records();
  },
  methods: {
    async fetch_cashflow_records() {
      let where_parameters = [... new Set(this.wheres)];
      where_parameters.push([
        {
            column: "investment_name",
            type: "=",
            params: [this.record.investment_name]
        }        
      ])
      const params = {
        where_parameters,
        order_parameters: [{ key: "funding_year", direction: "ASC" }]
      };
      this.cashflow_records = await OpenData.getResults(this.$OPEN_DATA_API, params);
    },
    open() {
        document.body.classList.add("modal-open");
    },
    modal_click(e) {
      if (!hasParentWithClass(e, "modal-content")) {
        this.close();
      }
    },
    close() {
      document.body.classList.remove("modal-open");
      this.$emit("close");
    },
    marker_options(record) {
      if (this.google && this.google.maps) {
        const percent_funded = record.sum_funded / record.sum_capital_cost;
        const colour = (percent_funded <= 0) ? '#CE2334' : ((percent_funded >= 1) ? '#00AB4E' : '#FFB71B');
        return {
          icon: {
            // eslint-disable-next-line
            path: this.google.maps.SymbolPath.CIRCLE,
            fillColor: colour,
            fillOpacity: 1,
            strokeWeight: 1,
            scale: 6
          },
          title: record.investment_name,
        };
      }
    }
  },
  computed: {
    location() {
      return (this.record.location) ? { lat: this.record.location.coordinates[1], lng: this.record.location.coordinates[0] } : false;
    },

    totalCapitalCost() {
      return parseInt(this.record.sum_funded || 0) + parseInt(this.record.sum_unfunded || 0);
    },

    google: gmapApi,

    cashflowRecords() {
      let rows = [];

      if (this.cashflow_years.start && this.cashflow_years.end) {
        for (let i = parseInt(this.cashflow_years.start); i <= parseInt(this.cashflow_years.end); i++) {
          rows.push({
            funding_year: i,
            sum_funded: "0.0",
            sum_unfunded: "0.0",
          })
        }
        this.cashflow_records.forEach(row => {
          rows[parseInt(row.funding_year) - parseInt(this.cashflow_years.start)].sum_funded = row.funded;
          rows[parseInt(row.funding_year) - parseInt(this.cashflow_years.start)].sum_unfunded = row.unfunded;
        })
      }
      return rows;
    },

    preliminary_cost() {
      let label = (this.budgetType == '6yearBudget') ? 'sum_preliminary_capital_cost_6_year' : 'sum_preliminary_capital_cost_10_year';
      return (label in this.record) ? this.record[label] : 0;
    },

    preliminary_forecasted() {
      let label = (this.budgetType == '6yearBudget') ? 'sum_preliminary_funded_6_year' : 'sum_preliminary_funded_10_year';
      return (label in this.record) ? this.record[label] : 0;
    },

    preliminary_unfunded() {
      let label = (this.budgetType == '6yearBudget') ? 'sum_preliminary_unfunded_6_year' : 'sum_preliminary_unfunded_10_year';
      return (label in this.record) ? this.record[label] : 0;
    }
  },

   components: { CashflowChart }
}
</script>

<style>
.preliminary-border {
  border: 1px solid black;
}
.modal-backdrop {
  opacity: .5;
}
.red { color: #FF0000 }
.yellow { color: #FFFF00 }
.green { color: #00FF00 }
</style>